import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeedbackAccessService } from '@core/services/feedback-access.service';

export const canActivateFeedback: CanActivateFn = async () => {
  const access = inject(FeedbackAccessService);
  const router = inject(Router);
  return await access.refresh() || router.createUrlTree(['/']);
};
